import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Copybar from '../../images/copy.png';
import stripLinhaDigitavel from '../../functions/linhaDigitavel';
import { getBancoHomologado } from '../../functions/bancosHomologados';
import './style.css';

// Painel "Detalhes do pagamento" (CA05) — substitui o antigo modal de
// detalhes por um card fixo na coluna lateral, no mesmo espaço do resumo de
// pagamento (Summary). Some quando `row` é nulo; quem decide quando mostrar
// um ou outro é o Dashboard/table.js.
// A ação "Pagar agora" só existe aqui quando nada está selecionado por
// checkbox (ver Dashboard/table.js) — por isso não há regra de "mais de uma
// parcela selecionada" a considerar neste painel; essa regra vale só para o
// ícone de segunda via na linha da tabela.
function PaymentDetailsPanel({
  row,
  eligibility,
  motivoIndisponibilidade,
  boletoIndisponivel,
  motivoBoletoIndisponivel,
  boletoFallbackDisponivel,
  onGerarSegundaVia,
  onPagarAgora,
}) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    setCopied(false);
  }, [row?.chave]);

  if (!row) return null;

  const boleto = row.boleto;
  const nomeBanco =
    getBancoHomologado(boleto?.codigo_banco)?.nome || boleto?.nome_banco;
  const atrasoExcedido = eligibility?.reason === 'atraso-excedido';
  const boletoDesabilitado = boletoIndisponivel || !eligibility?.eligible;
  const motivoBoletoDesabilitado = boletoIndisponivel
    ? motivoBoletoIndisponivel
    : motivoIndisponibilidade;

  return (
    <div className="col-md-4">
      <div className="my-1 p-3 bg-body rounded shadow-sm payment-details-panel">
        <h6 className="titulo-card pb-2 mb-0">Detalhes do pagamento</h6>

        <p className="payment-details-amount">R$ {row.price}</p>
        <p className={row.status === 'Em atraso' ? 'payment-details-due payment-details-due--late' : 'payment-details-due'}>
          Vencimento <strong>{row.date}</strong>
          {row.status === 'Em atraso' ? ' · em atraso' : ''}
        </p>

        {atrasoExcedido ? (
          <div className="alert alert-warning payment-details-alert" role="alert">
            {motivoIndisponibilidade}
          </div>
        ) : (
          <>
            <dl className="payment-details-list">
              <div className="payment-details-row">
                <dt>Documento</dt>
                <dd>{boleto?.numero_documento || '-'}</dd>
              </div>
              <div className="payment-details-row">
                <dt>Parcela</dt>
                <dd>01</dd>
              </div>
              <div className="payment-details-row">
                <dt>Contrato</dt>
                <dd>{row.contrato}</dd>
              </div>
              <div className="payment-details-row">
                <dt>Banco</dt>
                <dd>
                  {boleto?.codigo_banco || nomeBanco
                    ? `${boleto?.codigo_banco || ''}${
                        nomeBanco ? ` - ${nomeBanco}` : ''
                      }`
                    : '-'}
                </dd>
              </div>
              {(boleto?.agencia || boleto?.conta) && (
                <div className="payment-details-row">
                  <dt>Agência / Conta</dt>
                  <dd>
                    {boleto?.agencia} / {boleto?.conta}
                  </dd>
                </div>
              )}
              {(boleto?.carteira || boleto?.nosso_numero) && (
                <div className="payment-details-row">
                  <dt>Carteira / Nosso número</dt>
                  <dd>
                    {boleto?.carteira}
                    {boleto?.carteira ? ' / ' : ''}
                    {boleto?.nosso_numero}
                  </dd>
                </div>
              )}
            </dl>

            {row.codeBar && (
              <div className="payment-details-linha">
                <span>Linha digitável</span>
                <code>{row.codeBar}</code>
              </div>
            )}
          </>
        )}

        <div className="payment-details-actions">
          <Button variant="primary" size="lg" onClick={onPagarAgora}>
            Pagar agora
          </Button>

          {(boleto || boletoFallbackDisponivel) && (
            <Button
              variant="outline-primary"
              disabled={boletoIndisponivel}
              style={
                boletoDesabilitado && !boletoFallbackDisponivel
                  ? { opacity: 0.5 }
                  : undefined
              }
              title={
                boletoDesabilitado && !boletoFallbackDisponivel
                  ? motivoBoletoDesabilitado
                  : ''
              }
              onClick={onGerarSegundaVia}
            >
              {boleto ? 'Gerar segunda via' : 'Gerar boleto'}
            </Button>
          )}

          {/* Atraso excedido (CA10) já mostra o motivo no alerta acima. */}
          {boletoIndisponivel && !atrasoExcedido && (
            <p className="payment-details-hint">{motivoBoletoIndisponivel}</p>
          )}

          {!atrasoExcedido && row.codeBar && (
            <CopyToClipboard
              text={stripLinhaDigitavel(row.codeBar)}
              onCopy={() => setCopied(true)}
            >
              <Button variant="light" className="payment-details-copy">
                <img src={Copybar} alt="copiar" className="payment-details-copy-icon" />
                {copied ? 'Linha digitável copiada' : 'Copiar linha digitável'}
              </Button>
            </CopyToClipboard>
          )}
        </div>
      </div>
    </div>
  );
}

export default PaymentDetailsPanel;
